import { Component, OnInit } from '@angular/core';
import { CustomModalService } from '../../../../components/custom-modal';

@Component({
  selector: 'app-charges',
  templateUrl: './charges.component.html',
  styleUrls: ['./charges.component.scss']
})
export class ChargesComponent implements OnInit {

  constructor(private customModalService: CustomModalService) { }

  ngOnInit() {
  }
  closeModal(id:string){
    this.customModalService.close(id);
  }
}
